import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-all-leads',
  templateUrl: './all-leads.component.html',
  styleUrls: ['./all-leads.component.css']
})
export class AllLeadsComponent implements OnInit {

  public despositionArray   : any = AppSettings.disposition;
  public dispFirstEle       : any;
  public documentTypeArray  : any = AppSettings.documentType;
  public siteAbbr           : any = AppSettings.siteAbbr;
  public orderStatus        : any = AppSettings.orderStatus;

  public loading            : any = false;
  public submitted          : any = false;
  public paginatePage       : any;
  public leads              : any = [];
  public leads_Copy         : any = [];
  public comments           : any = [];
  public agentComments      : any = [];
  public qaComments         : any = [];
  public agentsSub          : any;
  public agents             : any;
  public qa                 : any;
  public loader             : any;
  public qaloader           : any;
  public activeUser         : any;
  public notes              : any = '';
  public lead_Index         : any = null;
  public addCommentForm     : FormGroup;
  public isMyTab            : any = false;
  public limitExceeded      : any = false;
  public leadStatusToUpdate : any = false;
  public floatingAlert      : any = true;
  public salesIndex         : any = null;
  public salesStatusVal     : any = null;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: DataTables.Settings = {};
  public dtTrigger: any = new Subject();

  public searchParams: any = { emailId: '', disposition: null, status: null, agent_id: [], date_from: '', date_to: '', work_type: null };
  public fullRangeDate: any;
  public selectedDesposition: any;
  public actionUpdated: any;

  constructor(
    private helperService: HelperService,
    private agentsService: Agents,
    private authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    // Get Agents
    this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
      if (agents) {
        this.agents = agents.agents;
        if (!this.agents.find(agent => agent.id === 'all')) {
          this.agents.unshift({ name: 'Select All', id: 'all' });
        }
        this.qa     = agents.qa;
      }
    });

    this.activeUser = this.authenticationService.get_currentUserValue();


    this.dtOptions = {
      paging: true,
      info: true,
      // ordering: false,
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      searching: false,
      'language': AppSettings.dataTableLang,
      "columnDefs": [
        { "orderable": false, "targets": 0 },
        { "orderable": true,  "targets": 1 },
        { "orderable": false, "targets": 2 },
        { "orderable": false, "targets": 3 },
        { "orderable": false, "targets": 4 },
        { "orderable": false, "targets": 5 },
        { "orderable": false, "targets": 6 },
        { "orderable": false, "targets": 7 },
        { "orderable": false, "targets": 8 },
      ],
      "order": [[1, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        // Show Loader
        this.loading = true;
        // console.log("dataTablesParameters", dataTablesParameters);

        let url = AppSettings.API_ENDPOINT + 'qa/leads';;

        let dtParams = {
          lead          : this.searchParams.emailId,
          disposition   : this.searchParams.disposition == null ? this.searchParams.disposition : this.searchParams.disposition.toString(),
          status        : this.searchParams.status,
          agent_id      : this.searchParams.agent_id,
          date_from     : this.searchParams.date_from ? this.helperService.caonvertDateToString(this.searchParams.date_from) : '',
          date_to       : this.searchParams.date_to ? this.helperService.caonvertDateToString(this.searchParams.date_to, false) : '',
          work_type     : (this.searchParams.work_type && this.searchParams.work_type.length > 0) ? this.searchParams.work_type : null,
          start         : dataTablesParameters.start,
          length        : dataTablesParameters.length,
          order         : dataTablesParameters.order,
          columns       : dataTablesParameters.columns
        };

        // For Record Serial Numbers
        this.paginatePage = dataTablesParameters.start;

        // Empty Data
        this.leads = [];

        this.helperService.httpPostRequestsDecryp(url, dtParams)
          .then(resp => {
            this.leads      = JSON.parse(resp);
            // console.log("this.leads: ", this.leads);

            this.leads_Copy = $.extend(true, {}, this.leads);


            // Set Default page len
            this.dtOptions.pageLength = this.dtElement['dt'].page.len();

            // Hide Loader
            this.loading = false;

            callback({
              recordsTotal: this.leads.total,
              recordsFiltered: this.leads.total,
              // recordsFiltered: resp['recordsFiltered'],
              // recordsFiltered: 1000,
              data: []
            });

            // // $(".paginate_button .current").css("color", "white");
            // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
            $('div.dataTables_length select').addClass('dt-form-control');
            $('div.dataTables_filter input').addClass('dt-form-control');
          })
          .catch(error => {
            // Set loader false
            this.loading = false;

            // // Rerender DT in case of failure
            // this.rerender();

            console.log("error: ", error);
          });
      },
      columns: [
        // { data: 'multiDelete' },
        { data: 'id' },
        { data: 'date' },
        { data: 'email' },
        { data: 'price' },
        { data: 'due_date' },
        { data: 'status' },
        { data: 'agent' },
        { data: 'qaComments' },
        { data: 'comments' },
      ],
      // Use this attribute to enable the responsive extension
      responsive: false
    }

  }

  ngOnInit() {
    this.addCommentForm = this.formBuilder.group({
      comment: [null, Validators.required],
    });
  }

  ngAfterViewInit() {
    this.dtTrigger.next();
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.agentsSub.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  selectAll() {
    if (this.searchParams.agent_id.includes('all')) {
      // If "Select All" is checked, select all agent IDs except 'all'
      this.searchParams.agent_id = this.agents
        .filter(agent => agent.id !== 'all')
        .map(agent => agent.id);
    } else if (this.searchParams.agent_id.length === 0) {
      // If no agent is selected, re-add "Select All"
      this.searchParams.agent_id = ['all'];
    }
    this.rerender()
  }

  splitFromTo() {
    if (this.fullRangeDate) {
      this.searchParams.date_from = this.fullRangeDate[0];
      this.searchParams.date_to = this.fullRangeDate[1];
    }

    this.rerender();
  }

  showComments(lead, index, type = "") {
    // this.loader = true;
    this.agentComments = [];
    this.qaComments    = [];

    if (type == 'QA-Leads-Comments') {
      this.qaloader = lead.id;
    } else {
      this.loader = lead.id;
    }

    let url = AppSettings.API_ENDPOINT + "shared/get-comments";
    let data = { l: lead.id, type: '' };
    this.helperService.httpPostRequests(url, data).then(resp => {
      if (typeof resp != "undefined") {
        this.comments = resp.data;

        for (let i = 0; i < this.comments.length; i++) {
          if (this.comments[i].type == "Leads-Comments") {
            this.agentComments.push(this.comments[i]);
          }
          else if (this.comments[i].type == "QA-Leads-Comments") {
            this.qaComments.push(this.comments[i]);
          }
        }

        if (type == 'QA-Leads-Comments') {
          $("#notesModal" + index).modal("show");
        } else {
          if (type == "" && this.agentComments.length == 0 && this.qaComments.length == 0) {
            Swal.fire('No comments', "Agents and QA haven't added any comments yet.", 'info');
          } else if (type == "Leads-Comments" && this.agentComments.length == 0) {
            Swal.fire('No comments', "Agents haven't added any comments yet.", 'info');
          } else {
            if (typeof $ != "undefined") {
              $("#comment_modal" + index).modal("show");
            }
          }
        }


        // Hide loaders
        this.loader = '';
        this.qaloader = '';

        $(".modal-backdrop").click(function() {
          $("#comment_modal" + index).modal("hide");
        });
      }

    });
  }

  get f() { return this.addCommentForm.controls; }

  showQAComments(lead, index) {
    // Show Loader
    this.leads.data[index].qaComLoader = true;

    // Reset Vars
    this.submitted = false;
    this.notes     = '';

    let url = AppSettings.API_ENDPOINT + "shared/get-comments";
    let data = { l: lead.id, type: 'QA-Leads-Comments' };

    this.helperService.httpPostRequests(url, data).then(resp => {
        if (typeof resp != "undefined") {
          this.comments   = resp.data;
          this.qaComments = [];

          for (let i = 0; i < this.comments.length; i++) {
            if (this.comments[i].type == "QA-Leads-Comments") {
              this.qaComments.push(this.comments[i]);
            }
          }
        }

        // Show Modal
        $("#notesModal" + index).modal("show");
        $(".modal-backdrop").click(function() {
          $("#notesModal" + index).modal("hide");
        });

        // Hide Loader
        this.leads.data[index].qaComLoader = false;
    }).catch(err => {
        // Hide Loader
        this.leads.data[index].qaComLoader = false;
    });
  }

  addNotes(lead, index) {
    // Set Submission True
    this.submitted = true;

    // Stop here if form is invalid
    if (this.addCommentForm.invalid) {
      return;
    }

    // Show Loader
    this.loading = true;


    let url = AppSettings.API_ENDPOINT + "shared/insert-note";
    let data = { l: lead.id, note: this.notes, type: 'QA-Leads-Comments' };

    this.helperService.httpPostRequests(url, data).then(resp => {
        if (typeof resp != "undefined") {
          this.cdr.detectChanges();
          $("#notesModal" + index).modal("hide");
          $('.modal-backdrop').remove();

          let self = this;
          this.leads.data[index].qaCommAdded = true;
          setTimeout(() => {
            self.leads.data[index].qaCommAdded = false;
          }, 1500);
        }

        // Hide Loader
        this.loading = false;
    }).catch(err => {
      Swal.fire('', 'Something went wrong. Please try again', 'error');

      // Hide Loader
      this.loading = false;
    });

    this.submitted = false;
  }

  agentSearch(id, agentArr) {
    for (var i = 0; i < agentArr.length; i++) {
      if (agentArr[i].id === id) {
        return agentArr[i].name;
      }
    }

    return '';
  }

  totalPaymentSearch(id, despoArr) {
    for (var i = 0; i < despoArr.length; i++) {
      if (despoArr[i].value === id) {
        return despoArr[i].name;
      }
    }

    return '';
  }

  clearFilters() {
    this.fullRangeDate = '';
    this.searchParams = {
      emailId: '',
      disposition: null,
      agent_id: [],
      date_from: '',
      date_to: '',
      work_type: null
    };

    this.rerender();
  }

  closeFloatingAlert(){
      this.floatingAlert = false;
  }

}
